import apiFetch from '../../apiFetch'

export default function (idIntervencionSanitaria, token) {
  return apiFetch({endPoint: `Intervencion/getIntervencion?idIntervencion=${idIntervencionSanitaria}`, method: 'GET', body: null, token: token})
}
